import { render } from "./InfoIcon.svg?vue&type=template&id=218f7218"
const script = {}
script.render = render

export default script